import { useEffect, useState } from "react";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Users } from "lucide-react";
import { listMyStudentTCs } from "@/lib/api/parent-invites.functions";

export const Route = createFileRoute("/_authenticated/selecionar-ct")({
  component: SelectTcPage,
});

const ACTIVE_KEY = "futbux:activeParentTc";

function SelectTcPage() {
  const navigate = useNavigate();
  const listFn = useServerFn(listMyStudentTCs);
  const [tcs, setTcs] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await listFn();
        const list = res.tcs ?? [];
        setTcs(list);
        if (list.length === 1) {
          try { localStorage.setItem(ACTIVE_KEY, list[0].training_center_id); } catch {}
          navigate({ to: "/responsavel/alunos" });
        }
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const pick = (tcId: string) => {
    try { localStorage.setItem(ACTIVE_KEY, tcId); } catch {}
    navigate({ to: "/responsavel/alunos" });
  };

  return (
    <div className="max-w-2xl mx-auto p-4 space-y-4">
      <h1 className="text-2xl font-bold">Escolha o Centro de Treinamento</h1>
      <p className="text-sm text-muted-foreground">
        Você tem alunos ativos em mais de um centro. Escolha em qual deseja entrar agora.
      </p>
      {loading ? (
        <p className="text-sm text-muted-foreground">Carregando…</p>
      ) : tcs.length === 0 ? (
        <Card>
          <CardContent className="p-6 text-center text-sm text-muted-foreground">
            Você ainda não tem alunos cadastrados em nenhum Centro de Treinamento.
          </CardContent>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {tcs.map((t) => (
            <Card key={t.training_center_id} className="hover:border-primary cursor-pointer" onClick={() => pick(t.training_center_id)}>
              <CardContent className="p-4 flex items-center gap-3">
                {t.tc_logo ? (
                  <img src={t.tc_logo} alt={t.tc_name} className="h-12 w-12 rounded-full object-cover" />
                ) : (
                  <div className="h-12 w-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <Users className="h-6 w-6 text-primary" />
                  </div>
                )}
                <div className="flex-1">
                  <p className="font-semibold">{t.tc_name}</p>
                  <p className="text-xs text-muted-foreground">
                    {t.active_students} aluno(s) ativo(s)
                  </p>
                </div>
                <Button size="sm">Entrar</Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
